module.exports = __webpack_public_path__ + "img/16l002-03.13693517.jpg";